import { render, staticRenderFns } from "./Kontakt.vue?vue&type=template&id=5f613821&scoped=true&"
import script from "./Kontakt.vue?vue&type=script&lang=js&"
export * from "./Kontakt.vue?vue&type=script&lang=js&"
import style0 from "./Kontakt.vue?vue&type=style&index=0&id=5f613821&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f613821",
  null
  
)

export default component.exports